import { http } from '@/lib'
import { Merchant, Reimbursement, Label } from '@/types/api'
import { useAsyncFn } from '@clara/hooks'

type MerchantCode = Merchant['code']

export type ReimbursementValues = Pick<
  Reimbursement,
  'amount' | 'description' | 'countryCode' | 'currencyCode' | 'attachments'
> & {
  expenseDate: string
  merchant: MerchantCode
  category: string
  userBank: string
  labels: Array<Partial<Label>>
}

export async function createReimbursement(values: ReimbursementValues) {
  return http.post('/', values).then((response) => response.data)
}

export function useCreateReimbursement() {
  return useAsyncFn(async (values: ReimbursementValues) => {
    const res = await createReimbursement(values)
    return res
  }, [])
}
